import React from 'react'
import { Container, Row, Col, Button, FormGroup, Label, Input, InputGroup, InputGroupAddon, FormFeedback } from 'reactstrap';
import { Field } from 'redux-form'


import { renderInput, renderSelect } from '../../utils/forms/renderers'
import { isRequired } from '../../utils/forms/validators'
import Loader from '../../core/components/Loader'
import { ButtonLoader } from '../../utils/loader'
import '../styles/style.css';
import '../styles/form.css';
import logo from '../../assets/images/upload.png'


export const renderInputTest = ({field, name, label, meta, file, readFile, input, role, valid, deleteDocument, validDocument}) => {

    if(file){
        var ext = file.split('.').pop();
        return(
          <FormGroup color={role === "superadmin" && valid && "success"}>
            <Label>{label}</Label>
             <InputGroup>
                <Input type="text" {...input} value={input.name+"."+ext}/>
                {role === "superadmin" &&
                <InputGroupAddon className="upload-delete upload-valid" onClick={() => validDocument(input.name, !valid)} >
                  {valid && "Dévalider" || "Valider"}
                </InputGroupAddon>
                }
                <InputGroupAddon className="upload-delete" onClick={() => deleteDocument(input.name)} >Supprimer</InputGroupAddon>

            </InputGroup>
          </FormGroup>
        )
      } else {
        return(
           <FormGroup color={meta.touched && meta.error ? 'danger' : ''} >
             <Label>{label}</Label>
             <div className="input-upload">
                <Label for={input.name}> <img src={logo} />Sélectionner un document </Label>
             </div>
             <Input className="hide-input-upload" type="file" name={input.name} id={input.name} onChange={(event) => readFile(event, input.name)}/>
             {meta.touched && meta.error && <FormFeedback className="error-form">{meta.error}</FormFeedback>}
          </FormGroup>
          )
      }
}


class FormStepFour extends React.Component {

	constructor(props) {
        super(props);

   }

   readFile(e, name){
      e.preventDefault();
      let reader = new FileReader();
      let file = e.target.files[0];
      this.props.uploadDocument(this.props.provider.provider.id, file, name)

   }

   deleteDocument(name){
      this.props.deleteDocument(this.props.provider.provider.id, name)
   }

   validDocument(name, bool){
      var obj = {};
      obj[`valid_${name}`] = bool
      this.props.validDocument(this.props.provider.provider.id, obj)
   }



    render() {
    	const { provider } = this.props.provider;
        const { handleSubmit, pristine, submitting, user, closePage, submitSucceeded} = this.props;

    	return (
            <div>
                <form role="form" >
                    <div className="provider-bloc-form">

                        <Row>
                            <Col>
                                <div className="title"> Pièces jointes </div>
                            </Col>
                        </Row>
                        {/*
                        <Row>
                            <Col>
                                  <Field
                                    name="contract"
                                    readFile={this.readFile.bind(this)}
                                    deleteDocument={this.deleteDocument.bind(this)}
                                    validDocument={this.validDocument.bind(this)}
                                    file={provider.contract}
                                    valid={provider.valid_contract}
                                    role={user.role}
                                    component={renderInputTest}
                                    label="Contrat (A renseigner après signature) " />
                              </Col>
                        </Row>
                        */}
                        <Row>
                            <Col>
                                  <Field
                                    name="kbis"
                                    readFile={this.readFile.bind(this)}
                                    deleteDocument={this.deleteDocument.bind(this)}
                                    validDocument={this.validDocument.bind(this)}
                                    file={provider.kbis}
                                    valid={provider.valid_kbis}
                                    role={user.role}
                                    component={renderInputTest}
                                    label="KBIS de moins de 3 mois" />
                              </Col>
                        </Row>

                        <Row>
                            <Col>
                                  <Field
                                    name="rcp"
                                    readFile={this.readFile.bind(this)}
                                    deleteDocument={this.deleteDocument.bind(this)}
                                    validDocument={this.validDocument.bind(this)}
                                    file={provider.rcp}
                                    valid={provider.valid_rcp}
                                    role={user.role}
                                    component={renderInputTest}
                                    label="Responsabilité Civile Professionnelle" />
                              </Col>
                        </Row>

                        {user.role !== "provider" &&
                          <Row>
                              <Col>
                                    <Field
                                      name="info_sheet"
                                      readFile={this.readFile.bind(this)}
                                      deleteDocument={this.deleteDocument.bind(this)}
                                      validDocument={this.validDocument.bind(this)}
                                      file={provider.info_sheet}
                                      valid={provider.valid_info_sheet}
                                      role={user.role}
                                      component={renderInputTest}
                                      label="Fiche de renseignement" />
                                </Col>
                          </Row>
                        }

                        <Row>
                            <Col>
                                  <Field
                                    name="urssaf"
                                    readFile={this.readFile.bind(this)}
                                    deleteDocument={this.deleteDocument.bind(this)}
                                    validDocument={this.validDocument.bind(this)}
                                    file={provider.urssaf}
                                    valid={provider.valid_urssaf}
                                    role={user.role}
                                    component={renderInputTest}
                                    label="Attestation URSSAF"/>
                              </Col>
                        </Row>

                        {user.role !== "provider" &&
                        <Row>
                            <Col>
                                  <Field
                                    name="price"
                                    readFile={this.readFile.bind(this)}
                                    deleteDocument={this.deleteDocument.bind(this)}
                                    validDocument={this.validDocument.bind(this)}
                                    file={provider.price}
                                    valid={provider.valid_price}
                                    role={user.role}
                                    component={renderInputTest}
                                    label="Bordereau de Prix"/>
                              </Col>
                        </Row>
                        }

                        {/*
                        <Row>
                            <Col>
                                  <Field
                                    name="result"
                                    readFile={this.readFile.bind(this)}
                                    deleteDocument={this.deleteDocument.bind(this)}
                                    validDocument={this.validDocument.bind(this)}
                                    file={provider.result}
                                    valid={provider.valid_result}
                                    role={user.role}
                                    component={renderInputTest}
                                    label="Bilan et compte de résultat" />
                              </Col>
                        </Row>
                        */}

                        {user.role !== "provider" &&
                        <Row>
                            <Col>
                                  <Field
                                    name="mappoint"
                                    readFile={this.readFile.bind(this)}
                                    deleteDocument={this.deleteDocument.bind(this)}
                                    validDocument={this.validDocument.bind(this)}
                                    file={provider.mappoint}
                                    valid={provider.valid_mappoint}
                                    role={user.role}
                                    component={renderInputTest}
                                    label="Carte Mappoint" />
                              </Col>
                        </Row>
                        }
                        {/*
                        <Row>
                            <Col>
                                  <Field
                                    name="rib"
                                    readFile={this.readFile.bind(this)}
                                    deleteDocument={this.deleteDocument.bind(this)}
                                    validDocument={this.validDocument.bind(this)}
                                    file={provider.rib}
                                    valid={provider.valid_rib}
                                    role={user.role}
                                    component={renderInputTest}
                                    label="RIB" />
                              </Col>
                        </Row>
                        */}
                        <Row>
                            <Col>
                                <Field
                                    name="free_text"
                                    type="string"
                                    component={renderInput}
                                    label="Informations complémentaires" />
                            </Col>
                        </Row>


                    </div>

                    <div>
                     <Row className="form-btn">

                        {this.props.create &&
                          <Col className="center">

                              <FormGroup>
                                  <Button className="btn-transparent" onClick={() => { this.props.previousPage(); window.scrollTo(0, 0)} }>Etape précédente</Button>

                                  {submitting &&
                                    <ButtonLoader />
                                  ||
                                   <Button className="btn-green" onClick={handleSubmit}>Etape suivante</Button>
                                  }

                            </FormGroup>
                          </Col>
                        }

                        {!this.props.create &&
                          <Col className="center">
                              <FormGroup>
                                <Button className="btn-transparent" onClick={closePage}>{submitSucceeded && "Retour à la fiche" || "Annuler"}</Button>

                                {submitting &&
                                  <ButtonLoader />
                                ||
                                  <Button className="btn-green" onClick={handleSubmit} >Enregistrer</Button>
                                }
                            </FormGroup>
                          </Col>
                        }


                      </Row>
                    </div>

                    <div className="provider-bloc-note">
                        * Champs obligatoires
                    </div>
                    <div className="provider-bloc-note">
                        Les informations recueillies sont nécessaires à HomeServe pour la gestion de votre candidature à notre réseau de prestataires agréé grâce à la création de votre compte prestataire.
                        Pour plus d’informations, consultez notre <a href={"https://homeserve.fr/politique-protection-donnees-personnelles"}> Politique de données personnelles. </a>
                        Conformément à la règlementation, vous bénéficiez d’un droit d’accès, de rectification, de limitation, de portabilité, d’effacement et d’opposition à l’utilisation de vos données personnelles ainsi que du droit de formuler des directives concernant la gestion de vos données post mortem.
                        Vous pouvez exercer ces droits en vous adressant auprès de HomeServe – Service Clients – TSA 82111 – 69303 Lyon Cedex 07 ou par mail à webmestre@homeserve.fr
                    </div>
                </form>
            </div>
        )
    }
}


export default FormStepFour



// WEBPACK FOOTER //
// ./src/provider/components/FormStepFour.js